import React, { useEffect } from 'react';
import { Header } from './Header';
import { ServicesSection } from './ServicesSection';
import { Footer } from './Footer';

export const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <ServicesSection />
      </main>
      <Footer />
    </div>
  );
};
